'use client'
import { createContext, useContext, useState } from 'react'

type TasksContextValue = {
  active: number
  increase: () => void
  decrease: () => void
}

export const TasksContext = createContext<TasksContextValue>({
  active: 0,
  increase: () => {},
  decrease: () => {},
})

export const useEvaluationTasksInProgress = () => useContext(TasksContext)

export const TasksContextProvider = ({ children }) => {
  const [tasksInProgress, setTasksInProgress] = useState<number>(0)

  const contextValue = {
    active: tasksInProgress,
    increase: () =>
      setTasksInProgress((prevTasksInProgress) => prevTasksInProgress + 1),
    decrease: () =>
      setTasksInProgress((prevTasksInProgress) =>
        Math.max(prevTasksInProgress - 1, 0)
      ),
  }

  return (
    <TasksContext.Provider value={contextValue}>
      {children}
    </TasksContext.Provider>
  )
}
